class LqdFancyHeadingHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);
    
    this.handleDestroy();

    this.initSplitText();
    this.initParallax();

  }
  
  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        parallaxElement: '[data-parallax]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $parallaxElement: this.$element.find(selectors.parallaxElement),
    }
  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  initParallax() {

    this.elements.$parallaxElement.liquidParallax();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleParallaxDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleParallaxDestroy() {

    if ( ! this.elements.$parallaxElement.length ) return;

    const parallaxData = this.elements.$parallaxElement.data('plugin_parallax');

    if ( parallaxData ) {
      parallaxData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFancyHeadingHandler, { $element } );
};